import { useState, useRef } from "react";
import useLenis from "../components/useLenis";
import ApplyHero from "./ApplyHero";
import ApplyWhoCanApply from "./ApplyWhoCanApply";
import ApplyBeforeYouBegin from "./ApplyBeforeYouBegin";
import ApplyTheJourney from "./ApplyTheJourney";
import ApplyProcess from "./ApplyProcess";
import ApplyForm from "./ApplyForm";
import ApplyCTA from "./ApplyCTA";
import Footer from "../components/Home/Footer";

export default function ApplyPage() {
  useLenis();
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef(null);

  const openForm = () => {
    setShowForm(true);
    // Scroll to form after it mounts
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
  };

  return (
    <>
      <ApplyHero onBegin={openForm} />
      <ApplyWhoCanApply />
      <ApplyBeforeYouBegin />
      <ApplyTheJourney />
      <ApplyProcess onBegin={openForm} />

      {/* Form — only rendered after user clicks Begin */}
      {showForm && (
        <div ref={formRef}>
          <ApplyForm />
        </div>
      )}

      <ApplyCTA onBegin={openForm} />
      <Footer />
    </>
  );
}
